import { Alert, Button, Space } from "antd";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import { BaseItem as ZhBaseItem, DetailHeader as ZhDetailHeader, Grid as ZhGrid } from "zhihao-ui-react";

import type { SystemRole } from "./types";
import { loadRole } from "./RoleFormPage";
import { RolePermissionSelector } from "./RolePermissionSelector";
import { DEFAULT_VALUE } from "@/config";
import { useUserStore } from "@/views/stores";

export interface RoleDetailPageProps {
    loadRole?: (id: number | string) => Promise<SystemRole>;
    permissions?: string[];
}

/** 角色详情页，沿用旧 Vue 查询接口并保持只读展示。 */
export function RoleDetailPage({ loadRole: load = loadRole, permissions }: RoleDetailPageProps) {
    const navigate = useNavigate();
    const location = useLocation();
    const storePermissions = useUserStore(state => state.userInfo.permissions || []);
    const storeBanButton = useUserStore(state => state.banButton);
    const currentPermissions = permissions || storePermissions;
    const canWrite = currentPermissions.includes("ROLE_ROLE_W");
    const editDisabled = permissions ? currentPermissions.includes("ROLE_BUTTON_BAN") : storeBanButton;
    const [role, setRole] = useState<SystemRole | null>(null);
    const [errorMessage, setErrorMessage] = useState<string | null>(null);
    const id = new URLSearchParams(location.search).get("id");

    useEffect(() => {
        if (!id) return;
        let disposed = false;
        void load(id)
            .then(result => {
                if (!disposed) setRole(result);
            })
            .catch(() => {
                if (!disposed) setErrorMessage("角色信息加载失败");
            });
        return () => {
            disposed = true;
        };
    }, [id, load]);

    return (
        <section className="flex h-full min-h-full flex-col" aria-label="role-detail-page">
            <div className="section-card max-w-4xl">
                <ZhDetailHeader title="角色详情" />
                {errorMessage ? <Alert className="mt-4" message={errorMessage} role="alert" type="error" /> : null}
                <div className="mb-4 mt-6 text-base font-medium">角色信息</div>
                <ZhGrid cols={4} gap={[30, 16]}>
                    <ZhBaseItem label="角色名称" value={role?.name || DEFAULT_VALUE} />
                    <ZhBaseItem label="角色说明" span={3} value={role?.remark || DEFAULT_VALUE} />
                    <ZhBaseItem label="权限编码" span={4}>
                        <RolePermissionSelector disabled value={role?.permissions || []} />
                    </ZhBaseItem>
                </ZhGrid>
                <Space className="mt-6">
                    {canWrite ? (
                        <Button
                            disabled={editDisabled}
                            type="primary"
                            onClick={() => void navigate(`/systemMangement/systemManage/role/edit?id=${id || ""}`)}
                        >
                            编辑
                        </Button>
                    ) : null}
                    <Button onClick={() => void navigate(-1)}>返回</Button>
                </Space>
            </div>
        </section>
    );
}

export default RoleDetailPage;
